import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class RecallListService {
  private apiEndpoint  = '/api/v2/groups/';

  constructor(
    private http: Http,
  ) { }

  get(groupId: number): Observable<any> {
    return this.http.get(`${this.apiEndpoint}${groupId}/recall_lists`, {  })
      .map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/recall-list/recall-list.service.ts